/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { formatBytes, getDateFormat } from "../../../../Utils/services.js";
import "react-datepicker/dist/react-datepicker.css";
import {
  getClientDocumentData,
  updateClientDocument,
  getDefaultTypeExpirationDate,
} from "../../../../Actions/Clients/clientsAction.js";
import { DEFAULT_DATE_FORMAT } from "../../../../consts/general.js";
import { API_DATE_FORMAT } from "../../../../consts/api.js";
import { withGlobalSettings } from "../../../../hocs/withGlobalSettings.js";
import { http } from "../../../../services/HttpService.js";
import { uiNotification } from "../../../../services/UINotificationService.js";
import { pipe } from "../../../../utilities/fp.js";
import { PageOverlayLoader } from "../../../../shared/PageOverlayLoader/PageOverlayLoader.js";
import { withDocumentTypes } from "./hocs/withDodumentTypes.js";
import { withDocumentCreate } from "./hocs/withDocumentCreate.js";
import { ALLOWED_FILE_TYPES } from "./config.js";
import { history } from "../../../../history.js";
import { CLIENTS_ROUTES } from "../../../../consts/routes.js";
import { getPathParams } from "./utilities.js";
import { withDocument } from "./hocs/withDocument.js";
import { withDocumentUpdate } from "./hocs/withDocumentUpdate.js";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox.js";
import { Box } from "../../../../shared/Box/Box.js";
import { Button } from "../../../../shared/Button/Button.js";

const initDocument = () => {
  return {
    document_name: "",
    filename: "",
    file_thumbnail: "",
    file_size: "",
    file_type: "",
    download_path: "",
    document_tag: "",
    document_description: "",
  };
};

const getFileType = (value) => {
  value = String(value);
  value = value.split(".").pop();

  if (!value) {
    return null;
  }

  value = value.toLowerCase();
  let fileType = "";

  if (["pdf"].indexOf(value) > -1) {
    fileType = "pdf";
  } else if (["png", "jpg", "jpeg", "gif"].indexOf(value) > -1) {
    fileType = "image";
  } else if (["xls", "xlsx"].indexOf(value) > -1) {
    fileType = "xls";
  } else if (["doc", "docs"].indexOf(value) > -1) {
    fileType = "doc";
  }

  return fileType;
};

class CreateEditPatientDocuments extends Component {
  constructor(props) {
    super(props);

    var { patientId, documentId } = getPathParams();

    this.state = {
      showLoader: false,
      clientID: patientId,
      documentID: documentId || 0,
      multipleDocumentList: [initDocument()],
      expirationDate: [],
      isEditInitialized: false,
    };

    this.expirationDateRef = React.createRef();
  }

  componentDidUpdate() {
    if (
      !this.state.isEditInitialized &&
      this.state.documentID &&
      this.props.document?.id
    ) {
      const doc = this.props.document;

      this.setState({
        isEditInitialized: true,
        canEdit: doc.can_edit,
        expirationDate: [doc.expiration_date?.split(/\s/)?.[0]].filter(Boolean),
        multipleDocumentList: [
          {
            document_name: doc.name,
            filename: doc.file_name || "",
            file_thumbnail: "",
            file_size: "",
            file_type: getFileType(doc.file_name),
            download_path: doc.file_url || "",
            document_tag: doc.doc_type,
            document_description: doc.description || "",
          },
        ],
      });
    }
  }

  componentDidMount() {
    getDefaultTypeExpirationDate({
      documentType: "file",
      createdDate: moment().format("YYYY-MM-DD"),
    }).then((response) => {
      if (!this.state.documentID) {
        const newExpirationDate = [
          ...this.state.expirationDate,
          response.data.data,
        ];
        this.setState({
          expirationDate: newExpirationDate,
          defaultExpirationDate: response.data.data,
        });
      }
    });
  }

  handleUpload = () => {
    let uploadtype = "patient_documents";

    const data = new FormData();

    data.append("file", this.state.file, this.state.file.name);
    data.append("upload_type", uploadtype);

    let endpoint = `media/upload?upload_type=${uploadtype}`;

    http
      .post(endpoint, data)
      .then((res) => {
        let multipleDocumentList = this.state.multipleDocumentList;
        let uploadIndex = this.state.uploadIndex;
        multipleDocumentList[uploadIndex]["filename"] = res.data.data.file_name;
        multipleDocumentList[uploadIndex]["file_thumbnail"] =
          this.state.file_thumbnail;
        multipleDocumentList[uploadIndex]["file_size"] = this.state.file_size;
        multipleDocumentList[uploadIndex]["download_path"] =
          this.state.fileReader.result;
        multipleDocumentList[uploadIndex]["file_type"] = getFileType(
          res.data.data.file_name,
        );
        this.setState({
          multipleDocumentList: multipleDocumentList,
          showLoader: false,
        });
      })
      .catch(() => {
        uiNotification.error("Unable to upload file. Please try again later.");
        this.setState({ showLoader: false });
      });
  };

  handleFileRead = () => {
    let fileSize = formatBytes(this.state.file.size, 1);

    this.setState({
      file_thumbnail: this.state.file.name,
      file_size: fileSize,
      file_src: this.state.fileReader.result,
      showLoader: true,
    });

    this.handleUpload(this.state.target.name);
  };

  handleFileChosen = (file, target) => {
    this.state.fileReader = new FileReader();
    this.state.fileReader.onloadend = this.handleFileRead;
    this.state.fileReader.readAsDataURL(file);
    this.state.file = file;
    this.state.target = target;
    this.state.uploadIndex = target.dataset.index;
  };

  handleInputChange = (event) => {
    this.setState({ userChanged: true });

    const target = event.target;
    let value = target.value;
    let inputName = target.name;

    const index = event.target.dataset.index;
    const multipleDocumentList = this.state.multipleDocumentList;

    multipleDocumentList[index][inputName] = value;
    this.setState({ multipleDocumentList: multipleDocumentList });

    if (target && target.type === "file") {
      if (
        target.files &&
        ALLOWED_FILE_TYPES.indexOf(target.files[0].type) > -1
      ) {
        this.handleFileChosen(target.files[0], target);
      } else {
        uiNotification.error("This file type is not allowed");
      }
    } else {
      this.setState({ [event.target.name]: value });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.documentID) {
      const obj = this.state.multipleDocumentList[0];
      this.props.updateDocument.initiate({
        name: obj.document_name,
        filename: obj.filename,
        doc_type: obj.document_tag,
        expiration_date: this.state.expirationDate[0],
        description: obj.document_description,
      });
    } else {
      this.props.createDocument.initiate(
        this.state.multipleDocumentList.map((obj, idx) => ({
          name: obj.document_name,
          filename: obj.filename,
          doc_type: obj.document_tag,
          expiration_date: this.state.expirationDate[idx],
          description: obj.document_description,
        })),
      );
    }
  };

  addMultipleDocumentList = () => {
    let multipleDocumentList = this.state.multipleDocumentList;
    multipleDocumentList.push(initDocument());

    let newExpirationDate = [
      ...this.state.expirationDate,
      this.state.defaultExpirationDate,
    ];

    this.setState({
      multipleDocumentList: multipleDocumentList,
      expirationDate: newExpirationDate,
    });
  };

  deleteMultipleDocumentList = (event) => {
    let multipleDocumentList = this.state.multipleDocumentList;

    if (multipleDocumentList.length == 1) {
      return false;
    }

    const index = event.target.dataset.index;

    multipleDocumentList.splice(index, 1);

    const newExpirationDate = this.state.expirationDate;
    newExpirationDate.splice(index, 1);

    this.setState({
      multipleDocumentList: multipleDocumentList,
      expirationDate: newExpirationDate,
    });
  };

  removeUploadedFile = (event) => {
    let multipleDocumentList = this.state.multipleDocumentList;
    const index = event.target.dataset.index;

    multipleDocumentList[index]["file_thumbnail"] = "";
    multipleDocumentList[index]["file_type"] = "";
    multipleDocumentList[index]["download_path"] = "";
    multipleDocumentList[index]["file_size"] = "";
    multipleDocumentList[index]["filename"] = "";

    this.setState({ multipleDocumentList: multipleDocumentList });
  };

  get isEfaxIntegrationActive() {
    return this.props.globalSettings?.efax_integration;
  }

  render() {
    let defLogo = this.state.documentID
      ? "/../../../../../images/upload.png"
      : "../../../../images/upload.png";

    let uploadProfile = this.state.documentID
      ? "/../../../../../images/file.png"
      : "../../../../images/file.png";

    return (
      <div id="content" className="content-client-documents">
        <div className="container-fluid content setting-wrapper">
          {this.state.isEditInitialized && !this.state.canEdit ? (
            <Box>
              <AlertBox>{`You can't edit this document`}</AlertBox>
              <Button
                size="small"
                className="m-t-10"
                onClick={() =>
                  history.push(CLIENTS_ROUTES.newDocuments(this.state.clientID))
                }
              >
                Go Back
              </Button>
            </Box>
          ) : (
            <div className="juvly-section full-width m-t-15">
              <div className="juvly-container">
                <div className="juvly-title m-b-40">
                  {this.state.documentID ? "Edit Document" : "Add Document"}
                  <button
                    onClick={() => {
                      history.push(
                        CLIENTS_ROUTES.newDocuments(this.state.clientID),
                      );
                    }}
                    className="pull-right btn-reset"
                  >
                    <img src="/images/close.png" alt="" />
                  </button>
                </div>
                <div className="juvly-subtitle no-margin">
                  Document Information
                </div>
                {this.state.multipleDocumentList.map((obj, idx) => {
                  return (
                    <div
                      key={"document-upload" + idx}
                      className="row add-doc-section"
                    >
                      <div className="col-xs-12 profile-detail-left no-margin">
                        <div className="main-profile-picture">
                          <div className="col-xs-6 no-padding">
                            <div
                              className="file-container file-upload-img"
                              title={obj.filename || ""}
                            >
                              {obj.filename && (
                                <button
                                  className="delete-file"
                                  onClick={this.removeUploadedFile}
                                  data-index={idx}
                                ></button>
                              )}
                              <img
                                alt=""
                                className={
                                  obj.file_type === "image" &&
                                  obj.download_path !== ""
                                    ? "full-custom-img"
                                    : ""
                                }
                                src={
                                  obj.file_type === "image" &&
                                  obj.download_path !== ""
                                    ? obj.download_path
                                    : obj.file_type !== "image" &&
                                      obj.download_path !== ""
                                    ? uploadProfile
                                    : defLogo
                                }
                              />
                              <span
                                className={
                                  obj.filename
                                    ? "file-name file-info"
                                    : "file-name-hide no-display"
                                }
                              >
                                {" "}
                                {obj.file_thumbnail}
                              </span>
                              <span
                                className={
                                  obj.filename
                                    ? "file-size file-info"
                                    : "file-size-hide no-display"
                                }
                              >
                                {obj.file_size}
                              </span>
                              <div className="upload">
                                Upload
                                <span className="setting-require">*</span>
                                <input
                                  type="file"
                                  className="image_questionnaire"
                                  name="file"
                                  autoComplete="off"
                                  onChange={this.handleInputChange}
                                  data-index={idx}
                                  title={obj.filename ? "" : "No file chosen"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4 col-xs-12">
                            <div className="setting-field-outer">
                              <div className="new-field-label">
                                Document Name
                                <span className="setting-require">*</span>
                              </div>
                              <div className="setting-input-outer">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="setting-input-box"
                                  name="document_name"
                                  value={obj.document_name}
                                  onChange={this.handleInputChange}
                                  data-index={idx}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-xs-12">
                            <div className="setting-field-outer">
                              <div className="new-field-label">
                                Document Type
                                <span className="setting-require">*</span>
                              </div>
                              <div className="setting-input-outer">
                                <select
                                  className="setting-select-box"
                                  name="document_tag"
                                  onChange={this.handleInputChange}
                                  data-index={idx}
                                  value={obj.document_tag || ""}
                                >
                                  <option value="">Select</option>
                                  {this.props.documentTypes.map(
                                    ({ value, label }) => (
                                      <option key={value} value={value}>
                                        {label}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 col-xs-12">
                            <div className="setting-field-outer no-margin">
                              <div className="new-field-label">
                                Expiration Date
                              </div>
                              <div className="setting-input-outer no-scroll">
                                <DatePicker
                                  pickerClassName="fontSize14px h-40"
                                  className="setting-select-box relative"
                                  showMonthDropdown
                                  showYearDropdown
                                  ref={this.expirationDateRef}
                                  onChangeRaw={(e) => e.preventDefault()}
                                  minDate={new Date()}
                                  onClickOutside={() =>
                                    this.expirationDateRef.current.setOpen(
                                      false,
                                    )
                                  }
                                  value={
                                    this.state.expirationDate[idx]
                                      ? moment(
                                          this.state.expirationDate[idx],
                                        ).format(
                                          getDateFormat() ||
                                            DEFAULT_DATE_FORMAT,
                                        )
                                      : "N/A"
                                  }
                                  onChange={(expiryDate) => {
                                    const newExpirationDate =
                                      this.state.expirationDate;
                                    newExpirationDate[idx] =
                                      moment(expiryDate).format(
                                        API_DATE_FORMAT,
                                      );
                                    this.setState({
                                      expirationDate: newExpirationDate,
                                    });
                                  }}
                                />
                                {this.state.expirationDate[idx] && (
                                  <button
                                    className="removeDateIcon btn-reset"
                                    onClick={() => {
                                      const newExpirationDate =
                                        this.state.expirationDate.filter(
                                          (_date, index) => index !== idx,
                                        );
                                      this.setState({
                                        expirationDate: newExpirationDate,
                                      });
                                    }}
                                  >
                                    <img alt="" src="/images/close.png" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-xs-12">
                            <div className="setting-field-outer">
                              <div className="new-field-label">Description</div>
                              <textarea
                                autoComplete="off"
                                className="setting-input-box"
                                name="document_description"
                                value={obj.document_description}
                                onChange={this.handleInputChange}
                                data-index={idx}
                                rows="5"
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.multipleDocumentList.length > 1 && (
                          <button
                            className="add-round-btn ml-10"
                            onClick={this.deleteMultipleDocumentList}
                            data-index={idx}
                          >
                            <span data-index={idx}>-</span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="add-document-btns">
                  {this.state.documentID == 0 && (
                    <button
                      className="new-blue-btn pull-right"
                      onClick={this.addMultipleDocumentList}
                    >
                      Add More Documents
                    </button>
                  )}
                  <p className="p-text pull-left">
                    Allowed file types: Images, PDF documents, Excel and Word
                    documents.
                  </p>
                </div>
              </div>
              <div className="footer-static">
                <button
                  className="new-blue-btn pull-right"
                  onClick={this.handleSubmit}
                >
                  Save
                </button>
                <button
                  onClick={() => this.props.history.goBack()}
                  className="new-white-btn pull-right"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        {(this.state.showLoader ||
          this.props.createDocument.isLoading ||
          this.props.updateDocument.isLoading ||
          this.props.isDocumentLoading) && (
          <PageOverlayLoader message="Loading. Please wait." />
        )}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getClientDocumentData,
      updateClientDocument,
    },
    dispatch,
  );
}

export default pipe(
  CreateEditPatientDocuments,
  withGlobalSettings,
  withRouter,
  withDocumentTypes,
  withDocumentCreate,
  withDocumentUpdate,
  withDocument,
  connect(null, mapDispatchToProps),
);
